import { render, staticRenderFns } from "./default-dialer.vue?vue&type=template&id=8de3bec0&scoped=true"
import script from "./default-dialer.vue?vue&type=script&lang=js"
export * from "./default-dialer.vue?vue&type=script&lang=js"
import style0 from "./default-dialer.vue?vue&type=style&index=0&id=8de3bec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de3bec0",
  null
  
)

export default component.exports